module.exports = __webpack_public_path__ + "img/ltkswim-3x.d80ddc1.jpg";